import { hotTopics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4">
            话题广场
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">全网最热吃瓜话题实时热度排行</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {hotTopics.map((topic) => (
            <a
              key={topic.id}
              href="#carousel"
              className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-full border text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/70 text-foreground-600 hover:border-primary-200 hover:text-primary-600'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              )}
              <span>{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}